export default __webpack_public_path__ + "static/media/Modello231.02eb2f91.png";